const { PAYMENT_PLAN_FREQUENCIES } = require('./constants')

// all auto payment plans made for loans have a start date of the next friday from the received due date
// the frequency days has to be multiple of 7.
// So we go with the nearest 7 figure denominator to the actual duration/frequency of the payment plan
const calculateStartDate = (dueDate, frequency = PAYMENT_PLAN_FREQUENCIES.WEEKLY) => {
  const frequencyDays = {
    WEEKLY: 0,
    BIWEEKLY: 14,
    FIFTEEN_DAYS: 14,
    MONTHLY: 28,
    FORTY_FIVE_DAYS: 42,
    BIMONTHLY: 56,
    TRIMONTHLY: 84
  }

  const date = new Date(dueDate)
  let daysToAdd = 0
  const dayOfWeek = date.getUTCDay()
  if (dayOfWeek < 5) {
    daysToAdd = (5 - dayOfWeek)
  } else if (dayOfWeek === 6) {
    daysToAdd = dayOfWeek
  } else {
    daysToAdd = (2 + dayOfWeek)
  }
  return new Date(date.setUTCDate(date.getUTCDate() + daysToAdd + (frequencyDays[frequency] || frequencyDays.WEEKLY))).toJSON().slice(0, 10)
}

module.exports = {
  calculateStartDate
}
